import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, Kamitaku, serchSelect, gmToolNewPage, gmTool } from "@/mixins/index";
import { hdTaskFlowPercentByUser } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "haidaoCheckpoint",
  mixins: [tabulation, Kamitaku, serchSelect, gmToolNewPage, gmTool],
  data: function data() {
    return {
      reqFn: hdTaskFlowPercentByUser,
      searchData: {
        tasks: '',
        is_new_register: 1,
        system_info: ''
      },
      Calculation: [{
        label: this.$t('personCount'),
        value: 'task_pnum'
      }, {
        label: this.$t('roiPercent'),
        value: 'task_percent'
      }],
      CalculationValue: 'task_pnum',
      StatisticalContent: [{
        label: this.$t('overallFlow'),
        value: '1'
      }, {
        label: this.$t('singleFlowStepLoss'),
        value: '2'
      }],
      userTypes: [{
        label: this.$t('newUserNumLabel'),
        value: 1
      }, {
        label: this.$t('activeUserNum'),
        value: 2
      }, {
        label: this.$t('newAndPayUser'),
        value: 3
      }, {
        label: this.$t('newNotPayUser'),
        value: 4
      }],
      devisionList: [{
        label: this.$t('android'),
        value: 'android'
      }, {
        label: "IOS",
        value: 'ios'
      }, {
        label: "windows",
        value: 'windows'
      }, {
        label: "mac",
        value: 'mac'
      }],
      StatisticalContentValue: '1',
      totalDynamic: [],
      totalDynamicValue: [],
      Dynamic: [],
      data_type: 'daily-task',
      more: true,
      searchUserType: this.$t('newUserNumLabel')
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  watch: {
    'searchData.country': {
      deep: true,
      handler: function handler(newVal, oldVal) {
        this.totalDynamicValue = [];
        this.searchData.tasks = '';
      }
    }
  },
  methods: {
    totalDynamicChange: function totalDynamicChange(ids) {
      var labels = [];
      this.totalDynamic.forEach(function (item) {
        if (ids.includes(item.value)) {
          labels.push(item.value);
        }
      });
      this.searchData.tasks = labels.toString();
    },
    getListnew: function getListnew() {
      var _this = this;

      this.searchData.server_id = this.paramsData.server_id;
      this.getList( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var taskKeys, userTypeObj, dataField, formattedDailyData, totalReg, totalPnumSum, totalRow;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.tableData = [];
                  _this.Dynamic = [];

                  if (res.all_keys_data && Array.isArray(res.all_keys_data)) {
                    _this.totalDynamic = res.all_keys_data.map(function (item) {
                      var _item$split = item.split('|'),
                          _item$split2 = _slicedToArray(_item$split, 2),
                          key = _item$split2[0],
                          value = _item$split2[1]; // 使用竖线分割


                      return {
                        label: value || key,
                        value: key,
                        tag: value || key
                      };
                    });
                  }

                  if (res.all_tasks && Array.isArray(res.all_tasks)) {
                    // 提取所有的 key 组成字符串给 searchData.tasks
                    taskKeys = res.all_tasks.map(function (item) {
                      return item.split('|')[0];
                    });
                    _this.totalDynamicValue = taskKeys;
                    _this.searchData.tasks = taskKeys.toString();
                    res.all_tasks.forEach(function (item) {
                      var _item$split3 = item.split('|'),
                          _item$split4 = _slicedToArray(_item$split3, 2),
                          key = _item$split4[0],
                          value = _item$split4[1];

                      _this.Dynamic.push({
                        label: value || key,
                        value: key
                      });
                    });
                  }

                  userTypeObj = _this.userTypes.find(function (i) {
                    return i.value == _this.searchData.is_new_register;
                  });
                  _this.searchUserType = userTypeObj ? userTypeObj.label : _this.$t('userNumLabel');
                  dataField = '';

                  if (_this.StatisticalContentValue == '1') {
                    // 总流程一览：根据计算方式选 user_count (人数) 或 percent (百分比)
                    dataField = _this.CalculationValue === 'task_pnum' ? 'user_count' : 'percent';
                  } else {
                    // 单个流程步骤损失：固定取 loss_percent
                    dataField = 'loss_task_percent';
                  }

                  formattedDailyData = res.daily_data.map(function (dayItem) {
                    var regNum = Number(dayItem.register_num) || 0;
                    var totalPnum = Number(dayItem.total_task_pnum) || 0;
                    var row = {
                      date: dayItem.date,
                      register_num: dayItem.register_num,
                      avg_task_num: regNum > 0 ? (totalPnum / regNum).toFixed(2) : "0.00"
                    }; // 遍历所有可能的任务列

                    _this.Dynamic.forEach(function (col) {
                      var taskId = col.value;
                      var taskName = col.label;

                      if (_this.StatisticalContentValue == '1') {
                        // 情况1：从 tasks 中取值。注意：后端 tasks 里的 key 是 task_name
                        var taskInfo = dayItem.tasks[taskName];

                        if (_this.CalculationValue == 'task_percent') {
                          row[taskId] = taskInfo ? taskInfo[dataField] + '%' : 0;
                        } else {
                          row[taskId] = taskInfo ? taskInfo[dataField] : 0;
                        }
                      } else {
                        // 情况2：从 loss_percent 中取值
                        row[taskId] = dayItem.loss_percent[taskName] !== undefined ? dayItem.loss_percent[taskName] + '%' : 0;
                      }
                    });

                    return row;
                  });

                  if (res.total_data) {
                    totalReg = Number(res.total_data.register_num) || 0;
                    totalPnumSum = Number(res.total_data.total_task_pnum) || 0;
                    totalRow = {
                      date: _this.$t('total'),
                      register_num: res.total_data.register_num,
                      avg_task_num: totalReg > 0 ? (totalPnumSum / totalReg).toFixed(2) : "0.00"
                    };

                    _this.Dynamic.forEach(function (col) {
                      var taskId = col.value;
                      var taskName = col.label;

                      if (_this.StatisticalContentValue == '1') {
                        var totalTaskInfo = res.total_data.tasks[taskName];

                        if (_this.CalculationValue == 'task_percent') {
                          totalRow[taskId] = totalTaskInfo ? totalTaskInfo[dataField] + '%' : 0;
                        } else {
                          totalRow[taskId] = totalTaskInfo ? totalTaskInfo[dataField] : 0;
                        }
                      } else {
                        totalRow[taskId] = res.total_data.loss_percent[taskName] !== undefined ? res.total_data.loss_percent[taskName] + '%' : 0;
                      }
                    });

                    if (_this.Dynamic.length) {
                      _this.Dynamic.push({
                        label: _this.$t('averageCheckpoint'),
                        value: 'avg_task_num'
                      });
                    } // 将合计行放入表格数组


                    formattedDailyData.push(totalRow);
                  }

                  _this.tableData = formattedDailyData;

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.searchUserType,
        prop: 'register_num'
      }];
      var data = [];
      this.Dynamic.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.value
        });
      });
      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};